import {
  getMainCategory,
  PostMainCategory,
  PostSubcategory,
} from '../domain/postCategories';
import navigationResource from '../../../locales/th/navigation.json';
import {
  getAllPropertyTypeValues,
  PropertyType,
} from '../domain/propertyTypes';

const mainCategoryToUrlComponentMap = new Map<PostMainCategory, string>([
  [
    PostMainCategory.ProjectResearch,
    navigationResource.landingPageRoutes.projectResearch.main,
  ],
  [
    PostMainCategory.LocationInsight,
    navigationResource.landingPageRoutes.locationInsight.main,
  ],
  [PostMainCategory.News, navigationResource.landingPageRoutes.news.main],
  [PostMainCategory.Guides, navigationResource.landingPageRoutes.guides.main],
  [PostMainCategory.Decor, navigationResource.landingPageRoutes.decor.main],
]);

export function generatePostMainCategoryLandingPageUrl(
  postMainCategory: PostMainCategory,
): string {
  return `/${mainCategoryToUrlComponentMap.get(postMainCategory)}/`;
}

const subcategoryToUrlComponentMap = new Map<PostSubcategory, string>([
  [
    PostSubcategory.Preview,
    navigationResource.landingPageRoutes.projectResearch.preview,
  ],
  [
    PostSubcategory.Review,
    navigationResource.landingPageRoutes.projectResearch.review,
  ],
  [
    PostSubcategory.PointOfView,
    navigationResource.landingPageRoutes.projectResearch.pov,
  ],
  [
    PostSubcategory.PropertyNews,
    navigationResource.landingPageRoutes.news.propertyNews,
  ],
  [
    PostSubcategory.GeneralNews,
    navigationResource.landingPageRoutes.news.generalNews,
  ],
  [
    PostSubcategory.BuyAndSell,
    navigationResource.landingPageRoutes.guides.buyAndSell,
  ],
  [
    PostSubcategory.Finance,
    navigationResource.landingPageRoutes.guides.finance,
  ],
  [
    PostSubcategory.Investment,
    navigationResource.landingPageRoutes.guides.investment,
  ],
  [
    PostSubcategory.InteriorInspiration,
    navigationResource.landingPageRoutes.decor.interiorInspiration,
  ],
  [
    PostSubcategory.Renovation,
    navigationResource.landingPageRoutes.decor.renovation,
  ],
  [
    PostSubcategory.Maintenance,
    navigationResource.landingPageRoutes.decor.maintenance,
  ],
]);

export function generatePostSubCategoryLandingPageUrl(
  postSubcategory: PostSubcategory,
): string {
  return `/${mainCategoryToUrlComponentMap.get(
    getMainCategory(postSubcategory),
  )}/${subcategoryToUrlComponentMap.get(postSubcategory)}/`;
}

export function generateHomePageUrl() {
  return '/';
}

export function generateComboLandingPageUrl(
  postSubcategory: PostSubcategory,
  propertyType: PropertyType,
): string | undefined {
  return `/${mainCategoryToUrlComponentMap.get(
    getMainCategory(postSubcategory),
  )}/${subcategoryToUrlComponentMap.get(
    postSubcategory,
  )}/${getAllPropertyTypeValues(propertyType)}/`;
}

export function generatePropertyTypeLandingPageUrl(propertyType: PropertyType) {
  if (!propertyType) {
    return generateHomePageUrl();
  }

  if (propertyType === PropertyType.Commercial) {
    return `/list/?q=${getAllPropertyTypeValues(propertyType)}`;
  }

  return `/${getAllPropertyTypeValues(propertyType)}/`;
}
